import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=1999ebb9&scoped=true"
import script from "./LegalInfo.vue?vue&type=script&lang=js"
export * from "./LegalInfo.vue?vue&type=script&lang=js"
import style0 from "./LegalInfo.vue?vue&type=style&index=0&id=1999ebb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1999ebb9",
  null
  
)

export default component.exports